import $ from "jquery";
import Swiper, {Navigation, Pagination} from "swiper";

export default class Warehouse {
    static instance = null;

    constructor(el) {
        this.$el = $(el)
        this.cityName = this.$el.data('city')
        this.geo = this.$el.data('geo')
        this.region = this.$el.data('region')
        this.api = this.$el.data('api')
        this.init()
        Warehouse.instance = this;
    }
    init() {
        this.$el.on('click', (e) => {
            e.preventDefault()
            const self = this;
            if ($(e.currentTarget).hasClass('acco__link')) {
                $('.acco__link').removeClass('current')
                $(e.currentTarget).addClass('current')
            }

            $.ajax({
                type:'GET',
                url: self.api,
                dataType:'json',
                data:{
                    city: self.cityName,
                    region: self.region,
                    geo: self.geo
                },
                success: function (data) {
                    if (data.success) {
                        const listHtml = self.generateListTemplate(data.data)
                        const listContainer = document.querySelector('.warehouse-block__info')
                        listContainer.innerHTML = listHtml
                        const swiperHtml = self.generateSwiperTemplate(data.data.photos);
                        const $swiperContainer = $('.warehouse-block__img-wrap')
                        if (data.data.photos.length > 0) {
                            $swiperContainer.html(swiperHtml);
                            const warehouseSwiper = new Swiper('.warehouse-swiper', {
                                modules: [Navigation, Pagination],
                                slidesPerView: 1,
                                slidesPerGroup: 1,
                                spaceBetween: 0,
                                mousewheel: true,
                                observer: true,
                                observeParents: true,
                                navigation: {
                                    nextEl: '.warehouse-swiper__button--next',
                                    prevEl: '.warehouse-swiper__button--prev',
                                },
                            });
                        } else {
                            $swiperContainer.html('');
                        }
                    }
                },
                error: function (data) {
                    console.log(data)
                }
            });
        })
    }

    generateSwiperTemplate(data) {
        const getSlideHtml = (item) => {
            return `<div class="swiper-slide warehouse-swiper__slide">
                        <img class="warehouse-swiper__slide-img" src="${item}" alt="" aria-hidden="true">
                    </div>
            `.trim()}

        return `<div class="swiper warehouse-swiper">
            <div class="swiper-wrapper">
                ${data.map(item => getSlideHtml(item)).join('').trim()}
            </div>
            <div class="warehouse-swiper__buttons-wrap">
                <button class="swiper-button warehouse-swiper__button warehouse-swiper__button--prev" type="button"><span class="visually-hidden">Предыдущий слайд</span></button>
                <button class="swiper-button warehouse-swiper__button warehouse-swiper__button--next" type="button"><span class="visually-hidden">Следующий слайд</span></button>
            </div>
        </div>`.trim()
    }

    generateListTemplate(data) {
        const {address, area, branch, gates, offices} = data

        const getBranchHtml = (branch) => {
            if (branch) {
                return `<li class="warehouse-block__info-item">${branch}</li>`.trim()
            }
            return '';
        }

        return `<ul class="warehouse-block__info-list">
                   <li class="warehouse-block__info-item">${address}</li>
                   ${getBranchHtml(branch)}
                   <li class="warehouse-block__info-item">${data['class']}</li>
                   <li class="warehouse-block__info-item">${area}</li>
                   <li class="warehouse-block__info-item">${offices}</li>
                   <li class="warehouse-block__info-item">${gates}</li>
                </ul>`.trim()
    }
}
